import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useNavigate } from "flemo";

import { generateExam } from "@/api/exams";
import { useAuthStore } from "@/store/authStore";
import { useSettingsStore } from "@/store/settingsStore";

export type GenerateExamInput =
  | string
  | {
      examDate: string;
      /** 온보딩 스타터 테스트처럼 이번 생성에만 적용할 문항 수 */
      questionCount?: number;
      /** 이후 테스트 퍼널에서 진입 출처를 구분하기 위한 분석용 값 */
      entry?: "onboarding_starter";
    };

/** 일일 테스트 생성 후 퀴즈 페이지로 이동 — 문항 수는 학습 설정(examQuestionCount)을 따른다 */
export function useGenerateExamMutation() {
  const userId = useAuthStore(state => state.user?.id);
  const examQuestionCount = useSettingsStore(state => state.examQuestionCount);
  const queryClient = useQueryClient();
  const { push } = useNavigate();

  return useMutation({
    mutationFn: (input: GenerateExamInput) => {
      const examDate = typeof input === "string" ? input : input.examDate;
      const questionCount = typeof input === "string" ? examQuestionCount : (input.questionCount ?? examQuestionCount);

      return generateExam(examDate, questionCount);
    },
    onSuccess: (examId: string, input: GenerateExamInput) => {
      queryClient.invalidateQueries({ queryKey: ["testDates", userId] });
      queryClient.invalidateQueries({ queryKey: ["exams", userId] });
      const entry = typeof input === "string" ? undefined : input.entry;
      push("/tests/:id", entry ? { id: examId, entry } : { id: examId });
    },
  });
}
